var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"segment-bar"},_vm._l((_vm.segmentlist),function(item,key){return _c('div',{staticClass:"segment",class:{ on: key==_vm.selectedIndex },on:{"click":function($event){$event.preventDefault();return _vm.handleSelect(key)}}},[_c('a',[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f206d362","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/segmentBar/segmentBar.vue
// module id = WzPe
// module chunks = 33